import { useEffect, useRef, useState } from 'react';

const useStateWithCallback = (initialState) => {
	const [state, setState] = useState(initialState);
	const ref = useRef();

	const setStateCallback = (newState, callback) => {
		ref.current = callback;
		setState(newState);
	};

	useEffect(() => {
		if (ref.current) {
			ref.current(state);
			ref.current = null;
		}
	}, [state]);
	return [state, setStateCallback];
};

export default useStateWithCallback;
